export default __webpack_public_path__ + "static/media/CERT.2b5d182a.jpg";